import { useContext } from 'react';

import CMSContext from '../contexts/CMSContext';

const useCmsValues = (...cmsIds) => {
  const ctx = useContext(CMSContext);
  return cmsIds.map((id) => ctx.get(id));
};

export default useCmsValues;
